import React, { useEffect, useState } from 'react';

import { FormContext, ColumnProps, MasterDetailForm, FormDatePicker, FormInput, FormSubmitButton, Widget } from '@digital/ui';
import {
  Table,
  Collapse,
  Icon
} from "antd";

import './custom.css';
import { FormikProps } from 'formik';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ordemCompraIdState, dadosGeraisState, reloadWidgetIdentificacaoState, desabilitarAcoesState } from '../atoms';
import moment from 'moment';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { ModalInclusaoMultAnexo, Visibility } from '@app/components';
import { copyWith, isObjNotEmpty } from '@app/helpers/objHelper';
import { getLoggedId } from '@app/helpers';
import {
  getByOrdemCompra,
  getComentarioBybidCycleOcV3,
  ajusteDatasBidCycleItemOcV3ByRealizado,
  updateAllByList
} from '@app/api/sas/bidCycleItemOcV3';
import { IBidCycleOcV3, IUpdateBidCycleOcV3, IUpdateBidCycleOcV3AllResponse } from '@app/models/BidCycleOrdemCompraModel';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import ModalComentarioButton from '@app/components/ModalComentarios';
import { onModalConfirm } from '@app/components/ModalConfirmEmail';

interface IProps {
  reload: boolean;
}

const TableBidCycleOrdemCompraV3 = ({ reload }: IProps) => {
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const dadosGerais = useRecoilValue(dadosGeraisState);
  const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);
  const [reloadWidgetIdentificacao, setReloadWidgetIdentificacao] = useRecoilState(reloadWidgetIdentificacaoState);

  const [loggedId] = useState(getLoggedId() || "");
  const [dataSource, setDataSource] = useState<IBidCycleOcV3[]>([]);
  const [update, setUpdate] = useState(false);
  const [modalJustificativa, setModalJustificativa] = useState(false);
  const [itemEditTemp, setItemEditTemp] = useState<IBidCycleOcV3>({} as IBidCycleOcV3);

  const [listEdit, setListEdit] = useState<IUpdateBidCycleOcV3[]>([]);


  const [formValues, setFormValues] = useState<any>([]);

  const getTableData = () => {
    if (ordemCompraId) {
      getByOrdemCompra(ordemCompraId)
        .then((data: any) => {
          if (data) {
            setDataSource(data.allBids);
          }
        });
    }
  };

  useEffect(() => {
    ajusteDatasBidCycleItemOcV3ByRealizado(ordemCompraId)
      .then(() => {
        getTableData();
      });
  }, [update, ordemCompraId, reload]);

  const addNewBidEdit = (record: IBidCycleOcV3, newBid: IUpdateBidCycleOcV3) => {
    let bidBkp = listEdit.find(f => f.bidCycleOcV3Id == record.id);
    const bidFinal = copyWith(bidBkp, newBid) as IUpdateBidCycleOcV3;
    let bidEditadosTemp = listEdit.filter(f => f.bidCycleOcV3Id !== record.id);
    bidEditadosTemp.push(bidFinal);
    setListEdit(bidEditadosTemp);
  };

  const handleSalvarBaselineInformarRequisitante = async (values: any) => {
    onModalConfirm({
      onOk: async (...args) => {
        await updateAllByList({
          ordemCompraId: ordemCompraId,
          allBidsEdit: listEdit,
          enviarEmail: true,
          isPersist: true
        });
        setReloadWidgetIdentificacao(!reloadWidgetIdentificacao);
        setUpdate(!update);
        setListEdit([]);
      },
      onCancel: async (...args) => {
        await updateAllByList({
          ordemCompraId: ordemCompraId,
          allBidsEdit: listEdit,
          enviarEmail: false,
          isPersist: true
        });
        setReloadWidgetIdentificacao(!reloadWidgetIdentificacao);
        setUpdate(!update);
        setListEdit([]);
      },
    });
  };

  useEffect(() => {
    // console.log('listEdit', listEdit);

    updateAllByList({
      ordemCompraId: ordemCompraId,
      allBidsEdit: listEdit,
      enviarEmail: false,
      isPersist: false
    })
      .then((data: IUpdateBidCycleOcV3AllResponse | undefined) => {
        if (data && data.valid) {
          setDataSource(data.allBids);
        }
      });

  }, [listEdit]);

  async function handleUpdateNegociadoDuracao(record: IBidCycleOcV3, justificativa: string) {
    if (record.negociado_Duracao) {

      let bidBkp = listEdit.find(f => f.bidCycleOcV3Id == record.id);

      const isInicio = bidBkp && bidBkp.isNegociadoDtInicio
        ? bidBkp.isNegociadoDtInicio
        : false;

      const newBid = {
        ordemCompraId: ordemCompraId,
        bidCycleOcV3Id: record.id,

        isNegociado: true,
        isNegociadoDtInicio: isInicio,
        dataInicio: record.negociado_DataInicio,
        duracao: record.negociado_Duracao,
        justificativa: justificativa,

        isPersist: false,
      } as IUpdateBidCycleOcV3;

      addNewBidEdit(record, newBid);

      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }


  function handleUpdateDtInicioNegociado(record: IBidCycleOcV3, dt: Date) {
    if (dt) {

      const newBid = {
        ordemCompraId: ordemCompraId,
        bidCycleOcV3Id: record.id,

        isNegociado: true,
        isNegociadoDtInicio: true,
        dataInicio: dt,

        isPersist: false,
      } as IUpdateBidCycleOcV3;

      addNewBidEdit(record, newBid);
    }
  }

  // const debouncedSetModalJustificativa = vtDebounce(setModalJustificativa, 1000);
  // const debouncedGetTableData = vtDebounce(getTableData, 1000);

  const columns = (formProps: FormikProps<any> | undefined) => {
    const columns: ColumnProps<any>[] = [];

    columns.push({
      title: 'BID CYCLE',
      dataIndex: 'descricao',
      key: 'descricao',
      width: '200px',
      align: 'left'
    });

    columns.push({
      title: 'Baseline Orientativo',
      children: [
        {
          title: 'Data Início',
          dataIndex: 'orientativo_DataInicio_String',
        },
        {
          title: 'Data Término',
          dataIndex: 'orientativo_DataTermino_String',
        },
        {
          title: 'Duração Orientativa',
          dataIndex: 'orientativo_Duracao',
        },
        {
          title: 'Duração Acumulada',
          dataIndex: 'orientativo_DuracaoACM'
        }
      ]
    });

    columns.push({
      title: 'Baseline Negociado',
      children: [
        {
          title: 'Data Início',
          dataIndex: 'negociado_DataInicio_String',
          width: '150px',
          render: (text: string, record: IBidCycleOcV3, index: number) => {
            if (["Comunicação Contratada", "Envio Carta Convite"].includes(record.descricao) && formProps) {
              return <FormDatePicker
                format="DD/MM/YYYY"
                label=""
                name="negociado_DataInicio_String"
                onChange={(dataMoment, dataString) => {
                  if (formProps) {
                    const d = dataMoment
                      ? dataMoment.toDate()
                      : moment(dataString, dateFormat).toDate();
                    handleUpdateDtInicioNegociado(record, d);
                  }
                }}
                value={moment(record.negociado_DataInicio_String, dateFormat)}
                disabled={isObjNotEmpty(record.realizado_DataTermino_String)}
              />;
            }
            return <p>{record.negociado_DataInicio_String}</p>;
          }
        },
        {
          title: 'Data Término',
          dataIndex: 'negociado_DataTermino_String',
        },
        {
          title: 'Duração',
          dataIndex: 'negociado_Duracao',
          width: '100px',
          render: (text: string, record: IBidCycleOcV3, index: number) => {
            return <FormInput
              key={record.id}
              value={record.negociado_Duracao}
              name="negociado_Duracao"
              onChange={e => {
                record.negociado_Duracao = e.target.value;
              }}
              type="number"
              min="0"
              disabled={isObjNotEmpty(record.realizado_DataTermino_String)}
              onKeyDown={e => {
                if (e.keyCode === 13) {
                  setItemEditTemp(record);
                  setModalJustificativa(true);
                }
              }}
            />;
          }
        },
        {
          title: 'Duração Acumulada',
          dataIndex: 'negociado_DuracaoACM'
        },
        {
          title: 'Justificativa',
          align: 'center',
          render: (text: any, record: IBidCycleOcV3, index: number) => {
            return (
              <Visibility
                visible={true}
              >
                <ModalComentarioButton
                  tooltip='Justificativa'
                  titleModal='Justificativa'
                  showBadgeComments={true}
                  loadAllComentarios={() => {
                    if (record.hasComentarios) {
                      return getComentarioBybidCycleOcV3(record.id)
                        .then((data: any) => {
                          if (data) {
                            return data.comentarios.slice(-1);
                          }
                          return [];
                        })
                        .catch(() => {
                          return [];
                        });
                    }
                    return Promise.resolve([]);
                  }}
                  reloadComentarios={update}
                />
              </Visibility>
            );
          },
        },
      ]
    });

    columns.push({
      title: 'Realizado',
      children: [
        {
          title: 'Data Início',
          dataIndex: 'realizado_DataInicio_String',
        },
        {
          title: 'Data Término',
          dataIndex: 'realizado_DataTermino_String',
        },
        {
          title: 'Duração',
          dataIndex: 'realizado_Duracao',
          render: (text: string, record: IBidCycleOcV3, index: number) => {
            if (isObjNotEmpty(record.realizado_DataTermino_String)) {
              return <span>{record.realizado_Duracao}</span>;
            }
            return "";
          }
        },
        {
          title: 'Duração Acumulada',
          dataIndex: 'realizado_DuracaoACM'
        }
      ]
    });

    columns.push({
      title: 'Forecast',
      children: [
        {
          title: 'Data Início',
          dataIndex: 'forecast_DataInicio_String',
          render: (text: string, record: IBidCycleOcV3, index: number) => {
            if (isObjNotEmpty(record.realizado_DataTermino_String)) {
              return "";
            }
            return <span>{record.forecast_DataInicio_String}</span>;
          }
        },
        {
          title: 'Data Término',
          dataIndex: 'forecast_DataTermino_String',
          render: (text: string, record: IBidCycleOcV3, index: number) => {
            if (isObjNotEmpty(record.realizado_DataTermino_String)) {
              return "";
            }
            return <span>{record.forecast_DataTermino_String}</span>;
          }
        },
        {
          title: 'Duração',
          dataIndex: 'forecast_Duracao',
          render: (text: string, record: IBidCycleOcV3, index: number) => {
            if (isObjNotEmpty(record.realizado_DataTermino_String)) {
              return "";
            }
            return <span>{record.forecast_Duracao}</span>;
          }
        },
        {
          title: 'Duração Acumulada',
          dataIndex: 'forecast_DuracaoACM',
          render: (text: string, record: IBidCycleOcV3, index: number) => {
            if (isObjNotEmpty(record.realizado_DataTermino_String)) {
              return "";
            }
            return <span>{record.forecast_DuracaoACM}</span>;
          }
        }
      ]
    });

    columns.push({
      title: 'Dias Desvios Início',
      dataIndex: 'diasDesvioInicio',
    });
    columns.push({
      title: 'Desvio Acm Início',
      dataIndex: 'diasDesvioInicioACM',
    });
    columns.push({
      title: 'Dias Desvios Término',
      dataIndex: 'diasDesvioTermino',
    });
    columns.push({
      title: 'Desvio Acm Término',
      dataIndex: 'diasDesvioTerminoACM',
    });

    return columns;
  };

  return (
    <Visibility visible={(hasPermission(["SAS_VISUALIZAR_BID_CYCLE"])
      || hasPermissionPerfil([
        EGuidPerfilAcesso.GerenciaSenior,
        EGuidPerfilAcesso.AdministradorContratoMRN,
      ]))
    }>
      <Collapse
        bordered={false}
        defaultActiveKey="bidCycleOcV3"
        expandIcon={() => <Icon type="arrows-right_4" />}
      >
        <Collapse.Panel key="bidCycleOcV3" header="BidCycleOc">
          <Widget>
            <MasterDetailForm
              key="formTableBidCycleOrdemCompraV3"
              onSubmit={handleSalvarBaselineInformarRequisitante}
              actions={[
                isObjNotEmpty(dadosGerais) && dadosGerais.compradorId == loggedId && desabilitarAcoes === false ? (
                  <FormSubmitButton type="primary" noIcon style={{ marginTop: '16px' }}>
                    Salvar Baseline e Informar para Requisitante
                  </FormSubmitButton>) : null,
              ]}
            >
              <FormContext.Consumer>
                {({ formProps }) => {
                  formProps && setFormValues(formProps.values);
                  return (

                    <Table
                      className="tabela-bidcycle-oc"
                      columns={columns(formProps)}
                      dataSource={dataSource ? dataSource : []}
                      rowKey={'id'}
                      pagination={false}
                      expandIcon={props => {
                        return <></>;
                      }}
                    />

                  );
                }}
              </FormContext.Consumer>
            </MasterDetailForm>
          </Widget>
        </Collapse.Panel>
      </Collapse>


      <ModalInclusaoMultAnexo
        visible={modalJustificativa}
        buttonIcon="files-check_file_filled2"
        buttonTooltip='Justificativa'
        onSubmit={async (values: any) => {
          if (values.justificativa) {

            return handleUpdateNegociadoDuracao(itemEditTemp, values.justificativa)
              .then(() => {
                setItemEditTemp({} as IBidCycleOcV3);
                return true;
              })
              .catch(() => false);

          }
          return false;
        }}
        showJustificativa
        textButtonSave="Salvar"
        showUploadArquivos={false}
        onlyModal={true}
        onlyModalOpenController={modalJustificativa}
        onChangeOpen={setModalJustificativa}
      />


    </Visibility>
  );
};

export default TableBidCycleOrdemCompraV3;
